import { Button, ButtonGroup, Paper, Popover } from "@mui/material";
import React, { useCallback, useState } from "react";
import { ArrowDropDownRounded } from "resource/muiImport";
import BoxFC from "./BoxFC";

const dfAnchorOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
}
const dfTransformOrigin = {
  vertical: 'top',
  horizontal: 'right',
}

const ButtonDropDown = ({
  children,
  buttonIcon,
  buttonText,
  onButtonClick,
  buttonOptions = [],
  size = "medium",
  arrowSize = "medium",
  anchorOrigin = dfAnchorOrigin,
  transformOrigin = dfTransformOrigin,
}) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, [])
 
  return (
    <ButtonGroup sx={{ minWidth: 0 }}>
      <Button variant="contained" size={size} onClick={onButtonClick}>{buttonIcon}{buttonText}</Button>
      <Button variant="contained" size={size}
        sx={size === "small" || arrowSize === "small" ? { minWidth: "0px !important", width: 25, padding: 0 } : {}}
        aria-controls={open ? "split-button-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-label="select"
        aria-haspopup="menu"
        onClick={(e) => { setAnchorEl(e.currentTarget) }}
      >
        <ArrowDropDownRounded />
      </Button>
      <Popover
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        open={open}
        role={undefined}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        {children ? children :
          <Paper sx={{p: 1}}>
            <BoxFC sx={{ padding: 0 }}>
              {buttonOptions.map((option, index) => {
                return (
                  <Button variant="contained" size={size}
                    key={index}
                    onClick={() => {
                      handleClose();
                      option.onClick()
                    }}
                  >
                    {option.icon}
                    {option.label}
                  </Button>
                )
              })}
            </BoxFC>
          </Paper>
        }
      </Popover>
    </ButtonGroup>
  );
}

export default React.memo(ButtonDropDown);